<mwe-basic-card
  iconClass="fa-solid fa-file-user"
  [cardTitle]="cardTitle()"
  headingNodeType="h2"
  data-test="products-summary-personalBilling"
  [hasBackground]="true"
  headingNodeType="h2"
>
  @if (email()) {
    <div data-test="products-summary-personalData-email">
      <mwe-headline
        headlineNodeType="h3"
        data-test="products-summary-personalData-email-headline"
        cssClass="font-size-16 lh-base"
        text="summary.invoiceCard.customerData.title"
      />
      <strong class="d-inline-block mb-3"><span translate="summary.invoiceCard.customerData.email"></span>: </strong> {{ email() }}
      @if (emailMessageInfoKey()) {
        <mwe-infobox [messageKey]="emailMessageInfoKey()" [textParams]="{ email: email() }" />
      }
    </div>
    <hr />
  }
  @if (contractInfos()?.length) {
    @for (contractInfo of contractInfos(); track contractInfo) {
      <mwe-product-summary-contract-info [contractInfos]="contractInfo" />
      <hr />
    }
  }
  <div data-test="products-summary-personalBilling-payment">
    <mwe-headline headlineNodeType="h3" cssClass="font-size-16 lh-base" text="summary.paymentData" />
    <div class="row mb-1 mt-1">
      <div class="col col-auto">
        <div class="payment-badge">
          <img class="img-fluid" src="/assets/icons/payment/{{ paymentIcon() }}.svg" [alt]="paymentIcon()" />
        </div>
      </div>
      <div class="col">
        <p class="text--big mb-0" [innerHTML]="paymentText()"></p>
      </div>
    </div>
    @if (paymentInfo()) {
      <mwe-infobox [messageKey]="paymentInfo()" class="d-block mt-3" />
    }
  </div>
  <hr />
  <div data-test="products-summary-personalBilling-eBilling">
    <mwe-headline headlineNodeType="h3" cssClass="font-size-16 lh-base" text="summary.invoiceShipping" />

    @if (eRechnungInfo()?.isERechnungsEmpfaenger) {
      <p [innerHTML]="'summary.invoiceAddress.method.email' | translate | safeHtml" class="mb-1"></p>
      <p class="mb-1" data-test="products-summary-personalBilling-email">
        <b translate="summary.invoiceAddress.method.emailAddress"></b> {{ eRechnungInfo().rechnungEmail }}
      </p>
    } @else {
      <p [innerHTML]="'summary.invoiceAddress.method.post' | translate | safeHtml" class="mb-1"></p>
    }

    <p class="mb-1">
      <b><span translate="summary.eBilling"></span>: </b>
      <span class="d-inline-block mb-2" data-test="products-summary-personalBilling-invoice-address"> {{ formattedInvoiceAddress() }}</span>
    </p>
  </div>
  @if (additionalBulletPoints().length) {
    <ul class="list-separated spacing-4 mt-5">
      @for (point of additionalBulletPoints(); track $index) {
        <li [attr.data-test]="point.id">
          <mwe-headline headlineNodeType="h4" cssClass="font-size-16 lh-base" [text]="point.title" />
          <p class="text--big mb-0">
            {{ point.text | translate }}
          </p>
        </li>
      }
    </ul>
  }
  @if (areBankAccountInfoTextsVisible() && !showBankAccountInfoTextAsAlert()) {
    <div class="mt-3">
      <mwe-new-bank-account-info-texts
        useTemplate="info-text"
        [hasSpotTariff]="hasSpotTariff()"
        [productCategories]="productCategories()"
      />
    </div>
  }
</mwe-basic-card>
@if (invoiceInfoAlertMessage()) {
  <mwe-alert [messageKey]="invoiceInfoAlertMessage()" class="d-block mt-4" data-test="products-summary-personalBilling-eBillingAlert" />
}
@if (areBankAccountInfoTextsVisible() && showBankAccountInfoTextAsAlert()) {
  <div class="mt-4 mb-4">
    <mwe-new-bank-account-info-texts [hasSpotTariff]="hasSpotTariff()" [productCategories]="productCategories()" />
  </div>
}
